export async function downloadFileFromResponse(
	blobs: BlobPart[],
	contentDisposition: string,
	contentSplitString: string = 'filename=',
	transformFileName?: (fileName: string) => string
) {
	const url = window.URL.createObjectURL(new Blob(blobs));
	const link = document.createElement('a');
	link.href = url;
	let fileName = contentDisposition
		.split(contentSplitString)[1]
		.replace(/["']/g, '');

	if (transformFileName) {
		fileName = transformFileName(fileName);
	}

	link.setAttribute('download', fileName);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
